export default "/images/vendor/flag-icons/flags/4x3/va.svg?377775044411ccf4943f20abdd3dfaf0";